<script>
	import { userid } from '../utils';
	import { listClients } from '../configUtils';
	import MigrationForm from '../components/MigrationForm.svelte';
	let query = '';

	$: filterClients = (/** @type {any[]} */ clients) => {
		return clients.filter(
			(client) =>
				client.client_name.toLowerCase().includes(query.toLowerCase()) ||
				client.cid.toLowerCase().includes(query.toLowerCase())
		);
	};
</script>

<h1>all clients listed here</h1>

{#await listClients($userid)}
	loading....
{:then clients}
	{#if Array.isArray(clients)}
		<input type="text" bind:value={query} placeholder="Query clients by name or id" />
		<div class="scrl">
			<table align="left">
				<thead>
					<th>Name</th>
					<th>ID</th>
				</thead>
				<tbody>
					{#each filterClients(clients) as client}
						<tr>
							<td>
								<a href="?client={client.cid}#configs">{client.client_name} </a>
							</td>
							<td>
								<a href="?client={client.cid}#configs"> {client.cid}</a>
							</td>
						</tr>
					{/each}
				</tbody>
			</table>
		</div>
	{:else}
		<p>No configs found</p>
	{/if}
{:catch error}
	{error}
{/await}

<MigrationForm />

<style>
	table {
		width: 100%;
		border-collapse: collapse;
		color: #000;
	}
	tr,
	thead,
	tbody {
		border-bottom: 1px solid #000;
	}
	tr:nth-child(2n) {
		background-color: rgba(25, 25, 25, 0.08);
	}

	th,
	td {
		padding: 0.75em;
		text-align: left;
	}
	td:first-child,
	th:first-child {
		border-right: 1px solid #000;
	}

	thead {
		position: sticky;
		top: 0;
		background-color: #fff;
		z-index: 2;
	}

	.scrl {
		overflow-y: scroll;
		max-height: 500px;
		position: relative;
		border-radius: 12px;
		border: 1px solid #000;
	}
	input {
		padding: 1em;
		width: 100%;
		border: 1px solid #000;
		margin-bottom: 1em;
		border-radius: 12px;
	}
	input::placeholder {
		color: #000;
	}
</style>
